var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTraincompanyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44,5H8A3,3,0,0,0,5,8V44a3,3,0,0,0,3,3H44a3,3,0,0,0,3-3V8A3,3,0,0,0,44,5ZM7,21h6.83A2.18,2.18,0,0,1,16,23.17v3.66A2.18,2.18,0,0,1,13.83,29H7ZM45,44a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V42H42a1,1,0,0,0,0-2H7V37H40.08a3,3,0,0,0,3-3c0-1-1.53-3.32-3.83-6H24.17A2.18,2.18,0,0,1,22,25.83V23.17A2.18,2.18,0,0,1,24.17,21h8c-3.95-3.35-8.17-6-11.1-6H7V8A1,1,0,0,1,8,7H44a1,1,0,0,1,1,1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.71,9.29a1,1,0,0,0-1.42,0l-2,2a1,1,0,0,0,1.42,1.42L12,11.41l1.29,1.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTraincompanyLogo);
export default __webpack_public_path__ + "static/media/no_traincompany_logo.4449246a5c6e9c4a13748dfe18338d09.svg";
export { ForwardRef as ReactComponent };